import { useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import FormularioPresupuestos from '../../components/presupuestos/FormularioPresupuestos';
import ContactosHubspot from '../../components/presupuestos/ContactosHubspot';

const Presupuestos = () => {
  const [activeTab, setActiveTab] = useState('presupuestos');

  return (
    <div>
      <div style={{ marginBottom: '16px' }}>
        <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>
          Presupuestos
        </h1>
        <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
          Gestión de presupuestos
        </p>
      </div>
      <Nav tabs style={{ marginBottom: '16px' }}>
        <NavItem>
          <NavLink
            className={activeTab === 'presupuestos' ? 'active' : ''}
            onClick={() => setActiveTab('presupuestos')}
            style={{ cursor: 'pointer' }}
          >
            Presupuestos
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === 'hubspot' ? 'active' : ''}
            onClick={() => setActiveTab('hubspot')}
            style={{ cursor: 'pointer' }}
          >
            Clientes HubSpot
          </NavLink>
        </NavItem>
      </Nav>
      {activeTab === 'presupuestos' && <FormularioPresupuestos />}
      {activeTab === 'hubspot' && <ContactosHubspot />}
    </div>
  );
};

export default Presupuestos;
